@if (canSeeFavorites) {
  @if (!product.isFavorite) {
    <button class="btn btn-icon" (click)="toggleFavorites()" role="button">
      @if (!isUpdating) {
        <i class="fal fa-heart"></i>
      }
      @if (isUpdating) {
        <i class="fal fa-sync rotate"></i>
      }
    </button>
    Add to
    <a
      href="#"
      class="link link-underline small"
      (click)="navigateToFavorites($event)"
      >Favorites</a
    >
  } @else {
    <button class="btn btn-icon" role="button" (click)="toggleFavorites()">
      @if (!isUpdating) {
        <i class="fas fa-heart color-red"></i>
      }
      @if (isUpdating) {
        <i class="fal fa-sync rotate"></i>
      }
    </button>
    Remove from
    <a
      href="#"
      class="link link-underline small"
      (click)="navigateToFavorites($event)"
      >Favorites</a
    >
  }
}
